import { Link } from 'react-router-dom';

interface BreadcrumbItem {
  label: string;
  href?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  const schema = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map((item, idx) => ({
      '@type': 'ListItem' as const,
      position: idx + 1,
      name: item.label,
      item: item.href ? `https://www.hanmanwu.com${item.href}` : undefined,
    })),
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(schema)}</script>
      <nav aria-label="面包屑导航" className="flex items-center text-sm text-foreground-600 py-3 px-4 md:px-6">
        <ol className="flex items-center flex-wrap gap-1">
          {items.map((item, idx) => (
            <li key={idx} className="flex items-center">
              {idx > 0 && (
                <span className="mx-2 text-foreground-400" aria-hidden="true">/</span>
              )}
              {item.href && idx < items.length - 1 ? (
                <Link
                  to={item.href}
                  className="text-foreground-600 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap"
                >
                  {item.label}
                </Link>
              ) : (
                <span className={idx === items.length - 1 ? 'text-foreground-900 font-medium' : 'text-foreground-600'}>
                  {item.label}
                </span>
              )}
            </li>
          ))}
        </ol>
      </nav>
    </>
  );
}